var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('admin-header',{attrs:{"name":_vm.$t('Vehicles'),"add-new":_vm.addNewBtn},on:{"create":_vm.newVehicle}}),_c('app-card',{staticClass:"mb-4"},[_c('router-view',{attrs:{"name":"vehicles"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }